const actions = {
  GET_USER_PROFILE: 'GET_USER_PROFILE',
  GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
  GET_USER_PROFILE_ERROR: 'GET_USER_PROFILE_ERROR',
};

export default actions;
